<template>
	<v-dialog
		v-if="parametersLoaded"
		v-model='isVisible'
		max-width="1000px">
		<v-card>
			<v-card-title>
				<span class="headline" v-if="!isEdited">Dodaj parametr oceny</span>
				<span class="headline" v-else>Edytuj parametr oceny</span>
			</v-card-title>
			<v-card-text>
				<v-layout row>
					<v-flex xs6>
						<egranty-text-input-field
							class="ma-2"
							v-model="newRatingParametersForm.criteriaName"
							label="Nazwa kryterium"
							for="contest-rating-parameters-add-dialog-name-criterion"
							id="contest-rating-parameters-add-dialog-name-criterion"
						></egranty-text-input-field>
						<egranty-number-input-field
							class="ma-2"
							v-model="newRatingParametersForm.minRating"
							label="Minimalna wartość"
							for="contest-rating-parameters-add-dialog-min-value"
							id="contest-rating-parameters-add-dialog-min-value"
						></egranty-number-input-field>
					</v-flex>
					<v-flex>
						<egranty-number-input-field
							class="ma-2"
							v-model="newRatingParametersForm.multiplier"
							label="Mnożnik"
							for="contest-rating-parameters-add-dialog-multiplier"
							id="contest-rating-parameters-add-dialog-multiplier"
						></egranty-number-input-field>
						<egranty-number-input-field
							class="ma-2"
							v-model="newRatingParametersForm.maxRating"
							label="Maksymalna wartość"
							for="contest-rating-parameters-add-dialog-max-value"
							id="contest-rating-parameters-add-dialog-max-value"
						></egranty-number-input-field>
					</v-flex>
				</v-layout>
				<div v-if="showRatingErrorMessage" style="color:red;">
					Minimalna wartość oceny nie może być większa od maksymalnej.
				</div>
				<div v-if="showEmptyFieldsErrorMessage" style="color:red;">
					Wszystkie pola są wymagane.
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="blue darken-1"
					@click="save"
					flat>
					{{isEdited ? 'Zapisz' : 'Dodaj'}}
				</v-btn>
				<v-btn @click="isVisible = false"
					color="blue">
					Anuluj
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import EgrantyNumberInputField from "../../../../genericComponents/EgrantyNumberInputField";
	import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";

	export default {
		name: "ContestRatingParametersDialog",

		components: {
			EgrantyNumberInputField, EgrantyTextInputField,
		},

		props: {
			editedItem: {type: Object, default: undefined},
			showDialog: Boolean
		},

		watch: {
			editedItem: {
				handler (val) {
					if (val !== undefined) {
						this.newRatingParametersForm.id = val.id;
						this.newRatingParametersForm.criteriaName = val.criteriaName;
						this.newRatingParametersForm.minRating = val.minRating;
						this.newRatingParametersForm.maxRating = val.maxRating;
						this.newRatingParametersForm.multiplier = val.multiplier;
						this.isEdited = true;
					}
					this.parametersLoaded = true;
				}
			},

			showDialog: {
				handler(val) {
					this.isVisible = val;
					if (this.isVisible) {
						this.parametersLoaded = true;
					}
				},
			},

			isVisible: {
				handler (val) {
					if (!val) {
						this.cancel();
					}
				}
			}
		},

		data() {
			return {
				isVisible: false,
				isEdited: false,
				showRatingErrorMessage: false,
				showEmptyFieldsErrorMessage: false,
				newRatingParametersForm: {
					id: null,
					criteriaName: "",
					minRating: null,
					maxRating: null,
					multiplier: null,
				},
				parametersLoaded: false
			};
		},

		methods: {
			cancel() {
				this.$emit("update:showDialog", this.isVisible);
				this.parametersLoaded = false;
				this.isEdited = false;
				this.clearForm();
			},

			save() {
				if (!this.pointsValid()) {
					this.showRatingErrorMessage = true;
					return;
				}
				this.showRatingErrorMessage = false;
				if (this.newRatingParametersForm.criteriaName === '' ||
					this.newRatingParametersForm.multiplier === null ||
					this.newRatingParametersForm.multiplier === '') {
					this.showEmptyFieldsErrorMessage = true;
					return;
				}
				this.showEmptyFieldsErrorMessage = false;
				this.$emit("save", this.newRatingParametersForm);
				this.isVisible = false;
			},

			pointsValid () {
				if (this.newRatingParametersForm.minRating === null) this.newRatingParametersForm.minRating = 0;
				if (this.newRatingParametersForm.maxRating === null) this.newRatingParametersForm.maxRating = 0;
				return parseInt(this.newRatingParametersForm.minRating) <= parseInt(this.newRatingParametersForm.maxRating);
			},

			clearForm() {
				this.newRatingParametersForm.id = null;
				this.newRatingParametersForm.criteriaName = "";
				this.newRatingParametersForm.minRating = null;
				this.newRatingParametersForm.maxRating = null;
				this.newRatingParametersForm.multiplier = null;
			},
		},
	};
</script>

<style scoped>

</style>
